import axios from 'axios';

import getTeamsUrl from '../utils/getTeamsUrl';

// Customer photos live on the teams server, which stores the files they are saved from.
const galleryUrl = () => `${getTeamsUrl(window.location.href)}/api/customer-gallery`;

export const CUSTOMER_PHOTOS_CHANGED = 'chekkit-customer-photos-changed';

export const saveTeamPhotoToCustomer = async ({ teamMessage, attachment }) => {
	try {
		const { data } = await axios.post(`${galleryUrl()}/save`, {
			_teamMessage: teamMessage._id,
			url: attachment.url,
		});

		if (!data.error) {
			window.dispatchEvent(
				new CustomEvent(CUSTOMER_PHOTOS_CHANGED, {
					detail: { _customer: data.photo?._customer },
				})
			);
		}

		return data;
	} catch (err) {
		return { error: true, message: err.response?.data?.message };
	}
};

export const getCustomerPhotos = async ({ _customer, _business, before }) => {
	const { data } = await axios.get(`${galleryUrl()}/${_customer}`, {
		params: { _business, before },
	});
	return data;
};

export const removeCustomerPhoto = async ({ _id }) => {
	const { data } = await axios.delete(`${galleryUrl()}/photo/${_id}`);
	return data;
};
